'use strict';
import DomElementBuilder from '../../sxQuery/DomElementBuilder';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
const COUNT_CLASS_NAME = 'ss360-category-tree__item-count';
const LINK_CLASS_NAME = 'ss360-category-tree__item';
const ACTIVE_CLASS_NAME = 'ss360-category-tree__item--active';
const UL_CLASS_NAME = 'ss360-category-tree';
const SHOW_MORE_BUTTON_CLASS_NAME = 'ss360-multiselect__show-more';
const EXPANDED_CLASS_NAME = 'ss360-category-tree-node--expanded';
class CategoryTree {
    constructor(wrapper, options, activeOptions, pluginConfiguration, changeCallback) {
        this.valueNodeMap = {};
        this.wrapperNodeMap = {};
        this.wrapper = wrapper;
        this.options = options;
        this.activeOptions = activeOptions;
        this.changeCallback = changeCallback;
        this.pluginConfiguration = pluginConfiguration;
        this.render();
    }
    update(options, activeOptions) {
        this.options = options;
        this.activeOptions = activeOptions;
        this.render();
    }
    getMappedActiveOptions() {
        return (this.activeOptions || []).map((option) => option.toString());
    }
    render() {
        const filterConfig = this.pluginConfiguration.filters;
        const showCounts = filterConfig.showCounts;
        const maxOptions = filterConfig.multiSelectShowMoreThreshold;
        const wrapper = this.wrapper;
        let activeOptions = this.getMappedActiveOptions();
        let options = this.options;
        if (!filterConfig.fullCategoryTree) {
            while (options.length === 1 && options[0].children !== undefined && options[0].children.length > 0) {
                options = options[0].children;
            }
        }
        const isChildSelected = (option) => {
            const children = option.children;
            if (children === undefined || children.length === 0) {
                return false;
            }
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (isSelected(child)) {
                    return true;
                }
                if (isChildSelected(child)) {
                    return true;
                }
            }
            return false;
        };
        const isSelected = (option) => (option.value !== undefined && activeOptions.indexOf(option.value) !== -1) || activeOptions.indexOf(option.conceptId.toString()) !== -1;
        const hiddenOptions = [];
        const valueNodeMap = {};
        const wrapperNodeMap = {};
        let ulLevel = 0;
        let mainGroup;
        const createGroup = (groupOptions, isRoot = false) => {
            const isUlCached = this.wrapperNodeMap[ulLevel] !== undefined;
            const ul = isUlCached ? this.wrapperNodeMap[ulLevel] : sxQuery(DomElementBuilder.createElement({
                tag: 'ul',
                classList: [UL_CLASS_NAME]
            }));
            wrapperNodeMap[ulLevel] = ul;
            ulLevel++;
            if (isRoot) {
                ul.addClass(`${UL_CLASS_NAME}--root`);
            }
            const groupHiddenOptions = {
                parent: ul,
                children: [],
                isExpanded: false
            };
            groupOptions.forEach((option, idx) => {
                const val = option.value !== undefined ? option.value : option.conceptId;
                const isCached = this.valueNodeMap[val] !== undefined;
                const selected = isSelected(option);
                const li = isCached ? this.valueNodeMap[val] : sxQuery(DomElementBuilder.createElement({
                    tag: 'li',
                    classList: ['ss360-category-tree__item-wrapper'],
                    children: [DomElementBuilder.createElement({
                            tag: 'a',
                            classList: [LINK_CLASS_NAME],
                            textContent: option.name,
                            attrs: {
                                href: '#'
                            }
                        })]
                }));
                const childLinks = li.findChildren(`.${LINK_CLASS_NAME}`);
                if (selected) {
                    childLinks.addClass(ACTIVE_CLASS_NAME);
                }
                else {
                    childLinks.removeClass(ACTIVE_CLASS_NAME);
                }
                if (showCounts && option.count !== undefined) {
                    if (isCached) {
                        li.findChildren(`.${COUNT_CLASS_NAME}`).text(`${option.count}`);
                    }
                    else {
                        li.append(DomElementBuilder.createElement({
                            tag: 'span',
                            classList: [COUNT_CLASS_NAME],
                            textContent: `${option.count}`
                        }));
                    }
                }
                valueNodeMap[val] = li;
                const isSpace = (e) => e.code === 'Space' || e.keyCode === 32 || e.which === 32;
                if (!isCached) {
                    const onChange = () => {
                        activeOptions = this.getMappedActiveOptions();
                        if (isSelected(option)) {
                            this.changeCallback(undefined);
                            childLinks.removeClass(ACTIVE_CLASS_NAME);
                        }
                        else {
                            childLinks.addClass(ACTIVE_CLASS_NAME);
                            this.changeCallback(val);
                        }
                    };
                    li.find('a').on('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        mainGroup.find(`.${ACTIVE_CLASS_NAME}`).removeClass(ACTIVE_CLASS_NAME);
                        onChange();
                    }).on('keydown', (e) => {
                        if (isSpace(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }).on('keyup', (e) => {
                        if (isSpace(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            onChange();
                        }
                    });
                }
                const isItemActive = (selected || isChildSelected(option));
                if (isItemActive && option.children !== undefined && option.children.length > 0) {
                    const $group = createGroup(option.children, false);
                    const groupNode = $group.get(0);
                    let isChild = false;
                    li.children().get().forEach((child) => {
                        isChild = isChild || child === groupNode;
                    });
                    if (!isChild) {
                        li.append($group);
                    }
                }
                else if (isCached) {
                    li.findChildren(`.${UL_CLASS_NAME}`).remove();
                    li.findChildren(`.${SHOW_MORE_BUTTON_CLASS_NAME}`).remove();
                }
                if (!isCached) {
                    ul.append(li);
                }
                const isExpanded = ul.hasClass(EXPANDED_CLASS_NAME);
                if (idx >= maxOptions && !isItemActive && !isExpanded) {
                    li.hide();
                    groupHiddenOptions.children.push(li);
                }
                else if (isExpanded) {
                    li.show();
                    groupHiddenOptions.isExpanded = true;
                }
                else if (idx < maxOptions) {
                    li.show();
                }
            });
            if (groupHiddenOptions.children.length > 0) {
                hiddenOptions.push(groupHiddenOptions);
            }
            else if (isUlCached && !groupHiddenOptions.isExpanded) {
                ul.parent().findChildren(`.${SHOW_MORE_BUTTON_CLASS_NAME}`).remove();
            }
            return ul;
        };
        mainGroup = createGroup(options, true);
        if (SxQueryUtils.indexInNodeList(mainGroup.get(0), wrapper.children().get()) === -1) {
            wrapper.append(mainGroup);
        }
        options.forEach((option, idx) => {
            const val = option.value !== undefined ? option.value : option.conceptId;
            const node = valueNodeMap[val];
            mainGroup.ensureChildPosition(node.get(0), idx);
        });
        hiddenOptions.forEach((group) => {
            const parentWrapper = group.parent.parent();
            const hasButtons = parentWrapper.findChildren(`.${SHOW_MORE_BUTTON_CLASS_NAME}`).length > 0;
            const showMoreLabel = filterConfig.multiSelectShowMoreLabel.replace(/#COUNT#/g, group.children.length.toString());
            if (hasButtons) {
                parentWrapper.findChildren(`.${SHOW_MORE_BUTTON_CLASS_NAME}--more`).text(showMoreLabel);
                return;
            }
            const showMoreButton = sxQuery(DomElementBuilder.createElement({
                tag: 'button',
                attrs: {
                    type: 'button'
                },
                classList: ['ss360-n-button', SHOW_MORE_BUTTON_CLASS_NAME, `${SHOW_MORE_BUTTON_CLASS_NAME}--more`],
                textContent: showMoreLabel
            }));
            const showLessButton = sxQuery(DomElementBuilder.createElement({
                tag: 'button',
                attrs: {
                    type: 'button'
                },
                classList: ['ss360-n-button', SHOW_MORE_BUTTON_CLASS_NAME, `${SHOW_MORE_BUTTON_CLASS_NAME}--less`],
                textContent: filterConfig.multiSelectShowLessLabel
            }));
            showMoreButton.on('click', () => {
                group.parent.addClass(EXPANDED_CLASS_NAME);
                group.children.forEach((option) => option.show());
                group.parent.findChildren('li').show();
                showMoreButton.remove();
                parentWrapper.append(showLessButton);
            });
            showLessButton.on('click', () => {
                group.parent.removeClass(EXPANDED_CLASS_NAME);
                showLessButton.remove();
                parentWrapper.append(showMoreButton);
                group.children.forEach((option) => option.hide());
            });
            parentWrapper.append(showMoreButton);
        });
        Object.keys(this.valueNodeMap).forEach((key) => {
            if (valueNodeMap[key] === undefined) {
                this.valueNodeMap[key].remove();
            }
        });
        this.valueNodeMap = valueNodeMap;
        this.wrapperNodeMap = wrapperNodeMap;
    }
}
export default CategoryTree;
